export default __webpack_public_path__ + "static/media/webber-michael.98ad6ded.jpg";